var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.1469,
    cy: 11.5688,
    r: 9.60784,
    fill: "url(#paint0_linear_53_33216)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7269 14.5071L15.1537 11.7953H12.4838V10.0364C12.4838 9.29429 12.8561 8.57052 14.0519 8.57052H15.2665V6.26184C15.2665 6.26184 14.1647 6.07861 13.1118 6.07861C10.912 6.07861 9.47553 7.37769 9.47553 9.72853V11.7953H7.03125V14.5071H9.47553V21.0631C9.96625 21.1382 10.4683 21.1767 10.9797 21.1767C11.4911 21.1767 11.9931 21.1382 12.4838 21.0631V14.5071H14.7269Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_53_33216",
    x1: 11.1469,
    y1: 1.96094,
    x2: 11.1469,
    y2: 21.1196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18ACFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0163E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.6e553731fdd372868931d81a96e236ea.svg";
export { ForwardRef as ReactComponent };